export default "__VITE_ASSET__Bxt4heOq__"